// QRC 由来項目(内数・最低発注単位・商品分類・商品コメント)の照会と反映をまとめる。
// 本文は HinbanMaster.js から移設したもの。

export function createQrcInfoService(deps) {
    const {
        DicVal,
        assignEntryDataCurrent,
        dispatch,
        entrydata,
        entrydataRef,
        entryrerender,
        firstNonEmptyValue,
        fnc,
        isEmpty,
        lastQrcMinHachuTaniKeyRef,
        lastQrcPackIrisuKeyRef,
        lastQrcSyohinBunruiCdKeyRef,
        lastQrcSyohinComentKeyRef,
        protectHbSeasonCommit,
        rerender,
        resolveBrandGroupBrandCode
    } = deps;

    function setQrcPackIrisuOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_QRC_PACKIRISU", "")).trim() === text) return false;
        targetData.PDT_QRC_PACKIRISU = text;
        return true;
    }
    function loadQrcPackIrisu(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const brandCode = String(resolveBrandGroupBrandCode(targetData)).trim();
        const itemCode = String(firstNonEmptyValue(targetData, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        const requestKey = `${brandCode}\t${itemCode}`;
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            lastQrcPackIrisuKeyRef.current = "";
            const cleared = setQrcPackIrisuOnEntryData(targetData, "");
            if (!cleared) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastQrcPackIrisuKeyRef.current === requestKey) {
            return;
        }
        lastQrcPackIrisuKeyRef.current = requestKey;

        fnc.current.postaxios("hinbanmaster/GetQrcPackIrisu",
            { BrandCode: brandCode, ItemCode: itemCode },
            {
                onSuccess: function (data) {
                    const nextValue = String(DicVal(data.returnData, "PDT_QRC_PACKIRISU", "")).trim();
                    const changed = setQrcPackIrisuOnEntryData(targetData, nextValue);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastQrcPackIrisuKeyRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "QRC商品入数の取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }
    function setQrcMinHachuTaniOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_QRC_MINHACHUTANI", "")).trim() === text) return false;
        targetData.PDT_QRC_MINHACHUTANI = text;
        return true;
    }
    function loadQrcMinHachuTani(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const brandCode = String(resolveBrandGroupBrandCode(targetData)).trim();
        const itemCode = String(firstNonEmptyValue(targetData, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        const requestKey = `${brandCode}\t${itemCode}`;
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            lastQrcMinHachuTaniKeyRef.current = "";
            const cleared = setQrcMinHachuTaniOnEntryData(targetData, "");
            if (!cleared) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastQrcMinHachuTaniKeyRef.current === requestKey) {
            return;
        }
        lastQrcMinHachuTaniKeyRef.current = requestKey;

        fnc.current.postaxios("hinbanmaster/GetQrcMinHachuTani",
            { BrandCode: brandCode, ItemCode: itemCode },
            {
                onSuccess: function (data) {
                    const nextValue = String(DicVal(data.returnData, "PDT_QRC_MINHACHUTANI", "")).trim();
                    const changed = setQrcMinHachuTaniOnEntryData(targetData, nextValue);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastQrcMinHachuTaniKeyRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "QRC最小発注単位の取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }
    function setQrcSyohinBunruiCdOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_QRC_SYOHINBUNRUICD", "")).trim() === text) return false;
        targetData.PDT_QRC_SYOHINBUNRUICD = text;
        return true;
    }
    function loadQrcSyohinBunruiCd(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const brandCode = String(resolveBrandGroupBrandCode(targetData)).trim();
        const itemCode = String(firstNonEmptyValue(targetData, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        const requestKey = `${brandCode}\t${itemCode}`;
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            lastQrcSyohinBunruiCdKeyRef.current = "";
            const cleared = setQrcSyohinBunruiCdOnEntryData(targetData, "");
            if (!cleared) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastQrcSyohinBunruiCdKeyRef.current === requestKey) {
            return;
        }
        lastQrcSyohinBunruiCdKeyRef.current = requestKey;

        fnc.current.postaxios("hinbanmaster/GetQrcSyohinBunruiCd",
            { BrandCode: brandCode, ItemCode: itemCode },
            {
                onSuccess: function (data) {
                    const nextValue = String(DicVal(data.returnData, "PDT_QRC_SYOHINBUNRUICD", "")).trim();
                    const changed = setQrcSyohinBunruiCdOnEntryData(targetData, nextValue);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastQrcSyohinBunruiCdKeyRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "QRC商品分類コードの取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }
    function setQrcSyohinComentOnEntryData(targetData, value) {
        if (isEmpty(targetData)) return false;
        const text = String(isEmpty(value) ? "" : value).trim();
        if (String(DicVal(targetData, "PDT_QRC_SYOHINCOMENT", "")).trim() === text) return false;
        targetData.PDT_QRC_SYOHINCOMENT = text;
        return true;
    }
    function loadQrcSyohinComent(options) {
        const requestOptions = isEmpty(options) ? {} : options;
        const targetData = isEmpty(DicVal(requestOptions, "targetData", null))
            ? entrydataRef.current
            : DicVal(requestOptions, "targetData", null);
        if (isEmpty(targetData)) return;

        const brandCode = String(resolveBrandGroupBrandCode(targetData)).trim();
        const itemCode = String(firstNonEmptyValue(targetData, ["PDT_ITMCITEMCD", "ITEMCD"])).trim();
        const requestKey = `${brandCode}\t${itemCode}`;
        if (isEmpty(brandCode) || isEmpty(itemCode)) {
            lastQrcSyohinComentKeyRef.current = "";
            const cleared = setQrcSyohinComentOnEntryData(targetData, "");
            if (!cleared) return;
            assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
            dispatch(entrydata({ ...entrydataRef.current }));
            dispatch(entryrerender());
            return;
        }

        if (!DicVal(requestOptions, "force", false) && lastQrcSyohinComentKeyRef.current === requestKey) {
            return;
        }
        lastQrcSyohinComentKeyRef.current = requestKey;

        fnc.current.postaxios("hinbanmaster/GetQrcSyohinComent",
            { BrandCode: brandCode, ItemCode: itemCode },
            {
                onSuccess: function (data) {
                    const nextValue = String(DicVal(data.returnData, "PDT_QRC_SYOHINCOMENT", "")).trim();
                    const changed = setQrcSyohinComentOnEntryData(targetData, nextValue);
                    if (!changed) return;
                    assignEntryDataCurrent(protectHbSeasonCommit(targetData, "targetData"), "targetData");
                    dispatch(entrydata({ ...entrydataRef.current }));
                    dispatch(entryrerender());
                },
                onError: function (data) {
                    lastQrcSyohinComentKeyRef.current = "";
                    if (!DicVal(requestOptions, "silent", true)) {
                        let msg = "商品コメントの取得に失敗しました";
                        if (!isEmpty(data.errDescription)) msg = data.errDescription;
                        fnc.current.warnmsg(msg);
                    }
                }
            }, true
        );
    }

    return {
        setQrcPackIrisuOnEntryData,
        loadQrcPackIrisu,
        setQrcMinHachuTaniOnEntryData,
        loadQrcMinHachuTani,
        setQrcSyohinBunruiCdOnEntryData,
        loadQrcSyohinBunruiCd,
        setQrcSyohinComentOnEntryData,
        loadQrcSyohinComent
    };
}
